import { useEffect } from 'react';
import { PracticeAnalyticsTypes } from '@frontend/api-analytics';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { useGetRecapturedPatientsMetric } from './hooks/use-get-recaptured-patients-metric';
import { usePracticeAnalyticsShallowStore } from './hooks/use-practice-analytics-store';
import { RecapturedMetricMulti } from './recaptured-metric-multi';
import { RecapturedMetricSingle } from './recaptured-metric-single';

const colors = {
  leadTime: theme.colors.critical40,
  patients: theme.colors.warning50,
  production: theme.colors.primary20,
};

export const RecapturedMetric = (props: PracticeAnalyticsTypes.MetricProps) => {
  const { isDrillDownPage, onFetchStateChange } = props;

  const { t } = useTranslation('analytics');
  const { filters } = usePracticeAnalyticsShallowStore('filters');
  const { aggregatedRecapturedPatientsData, isLoading, rawRecapturedPatientsData } = useGetRecapturedPatientsMetric();

  const multipleLocationsSelected = (filters.locations?.length || 0) > 1;
  const showLocationComparison = isDrillDownPage && multipleLocationsSelected;

  const labels = {
    leadTime: multipleLocationsSelected ? t('Avg Lead Time (Days)') : t('Lead Time (Days)'),
    patients: t('Recaptured Patients'),
    production: t('Recaptured Production ($)'),
  };

  useEffect(() => {
    onFetchStateChange?.(isLoading);
  }, [isLoading]);

  return showLocationComparison ? (
    <RecapturedMetricMulti
      {...props}
      colors={colors}
      data={{
        aggregatedData: aggregatedRecapturedPatientsData,
        rawData: rawRecapturedPatientsData,
      }}
      isLoading={isLoading}
      labels={labels}
    />
  ) : (
    <RecapturedMetricSingle
      {...props}
      colors={colors}
      data={{
        aggregatedData: aggregatedRecapturedPatientsData,
        rawData: rawRecapturedPatientsData,
      }}
      isLoading={isLoading}
      labels={labels}
    />
  );
};
